import { Typography } from "@mui/material"

export function Version(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Ver.1.1.0'}
        </Typography>
    );
}